import { makeAutoObservable } from 'mobx'

class AnnouncementsStore {
    public isGlobalAnnouncementVisible = false
    public isRegionalAnnouncementVisible = false
    public isCinemaAnnouncementVisible = false

    public constructor() {
        makeAutoObservable(this)
    }

    public setGlobalVisibility(visibilityState: boolean) {
        this.isGlobalAnnouncementVisible = visibilityState
    }

    public setRegionalVisibility(visibilityState: boolean) {
        this.isRegionalAnnouncementVisible = visibilityState
    }

    public setCinemaVisibility(visibilityState: boolean) {
        this.isCinemaAnnouncementVisible = visibilityState
    }

    public get canShowHelloBar() {
        return !(
            this.isGlobalAnnouncementVisible ||
            this.isRegionalAnnouncementVisible ||
            this.isCinemaAnnouncementVisible
        )
    }
}

export const announcementsStore = new AnnouncementsStore()
